import i18n from '@/locales/i18n';
import message from '@/utils/message';

function readErrMessage(err) {
  return String(err?.message ?? err?.msg ?? '').trim();
}

/** 充值/登录后自动签领成功 toast（dedupe，避免双入口连弹） */
export function notifyTrialFundAutoClaimSuccess() {
  try {
    message.success(i18n.global.t('trialFund.claimMintSyncInfo'), {
      dedupeKey: 'trial-fund-auto-claim',
    });
  } catch {
    /* i18n / toast soft-fail */
  }
}

/**
 * Map trial claim API errors to user-facing copy (never raw「系统内部错误 (500)」).
 * @param {unknown} err
 * @returns {string}
 */
export function resolveTrialClaimUserMessage(err) {
  const t = i18n.global.t;
  const raw = readErrMessage(err);
  const code = Number(err?.code);

  if (/already\s*claim|已经领取/i.test(raw)) {
    return '';
  }
  if (
    code === 400 &&
    /首次充值|deposit_required|trial\.deposit_required|再领取体验金|complete.*deposit.*claim/i.test(
      raw
    )
  ) {
    return t('trialFund.claimNeedDeposit');
  }
  if (/首次充值|deposit_required|trial\.deposit_required|再领取体验金/i.test(raw)) {
    return t('trialFund.claimNeedDeposit');
  }
  if (code === 503 || /grant\s*pending|正在发放|mint_pending|try\s*again/i.test(raw)) {
    return t('trialFund.claimPending');
  }
  if (/timeout|504|gateway\s*timeout/i.test(raw)) {
    return t('trialFund.claimPending');
  }
  if (/internal|系统内部|\(500\)/i.test(raw)) {
    return t('trialFund.claimRetryLater');
  }
  if (raw) {
    return raw;
  }
  return t('trialFund.claimRetryLater');
}

/**
 * @param {unknown} err
 * @returns {boolean}
 */
export function isTrialClaimDepositRequiredError(err) {
  const raw = readErrMessage(err);
  if (Number(err?.code) === 400 && /首次充值|deposit_required|trial\.deposit_required|再领取体验金/i.test(raw)) {
    return true;
  }
  return /首次充值|deposit_required|trial\.deposit_required|再领取体验金/i.test(raw);
}
